

import clsx from "clsx"
import ForgotPassword from "components/auth/forgotPassword"
import AuthLayout from "components/auth/layout"
import Modal from "components/auth/modal"
import SignIn from "components/auth/signIn"
import SignUp from "components/auth/signUp"
import { useState } from "react"
import useSWRInfinite from "swr/infinite"
import Comment from "./comment"
import Form from "./form"
import styles from "./index.module.scss"

type Props = {
    post_ID: number
    totalComments: number
    totalParentComments: number
    isMobileApp?: boolean
}
export default function Component({ post_ID, totalComments, totalParentComments, isMobileApp }: Props) {
    const [form, setForm] = useState("")
    const { data = [], isLoading, size, setSize, } = useSWRInfinite<PostComment[]>(i => `/api/nb/v3/comments?${new URLSearchParams({
        postID: String(post_ID),
        offset: String(i * 5),
    })}`, {
        fetcher: (url: string) => fetch(url).then(r => r.json()),
		onSuccess: () => {
			try {
				if(size > 1) {
					window?.gtag('event', 'page_view', {
						page_title: `${document.title}`,
						page_location: `${location.pathname}`
					})
				}
				
			} catch(err) {

			}
		}
    })

    const comments = data.flat()
    const hasMore = comments.length < totalParentComments

    return (
        <div id={`post-${post_ID}-comments`} className={styles.commentsSection}>
            <div className={styles.titleSection}>
                <div className={styles.commentsBubble}>{totalComments ?? 0}</div>
                <div className={clsx("sectionTitle", styles.title)}>Σχόλια αναγνωστών</div>
            </div>

            <Form comment_post_ID={post_ID} className={styles.commentsFrm} onSignIn={() => setForm("signIn")} isMobileApp={isMobileApp}/>

            <div className={clsx(styles.commentCnt, size == 1 && hasMore && styles.closed)}>
                {comments.map(C => (
                    <Comment
                        key={C.comment_ID}
                        onSignIn={() => setForm("signIn")}
                        comment_post_ID={String(post_ID)}
                        isMobileApp={isMobileApp}
                        {...C}
                    />
                ))}
            </div>

            {hasMore && (
                <button disabled={isLoading} onClick={() => setSize(size + 1)} className={clsx("cmnBtn", styles.openComments)}>
                    ΠΕΡΙΣΣΟΤΕΡΑ ΣΧΟΛΙΑ
                </button>
            )}

            <Modal show={!!form} onClose={() => setForm("")}>
                <AuthLayout form={form} setForm={setForm}>
                    {form === 'signIn' && <SignIn setForm={setForm} isMobileApp={isMobileApp}/>}
                    {form === 'signUp' && <SignUp setForm={setForm} />}
                    {form === 'forgotPassword' && <ForgotPassword setForm={setForm} />}
                </AuthLayout>
            </Modal>
        </div>
    )
}
